import axios from "@/api/axiosInstance";
import { FetchVouchersReportParams } from "./types";

export const fetchVouchersReportCsv = async (
  params: Omit<FetchVouchersReportParams, "page" | "pageSize"> = {},
): Promise<Blob> => {
  const response = await axios.get<Blob>(
    "/api/private/reports/vouchers/export",
    { responseType: "blob", params },
  );
  return response.data;
};
